/* tslint:disable */
/* eslint-disable */
/**
 * Litiverse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  HTTPValidationError,
} from '../models/index';
import {
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
} from '../models/index';

export interface SecRssCronApiV1CronSecRssGetRequest {
    date?: string | null;
    year?: number | null;
    month?: number | null;
    method?: string;
}

export interface SecRssCronApiV1CronSecRssGet0Request {
    date?: string | null;
    year?: number | null;
    month?: number | null;
    method?: string;
}

/**
 * 
 */
export class CronApi extends runtime.BaseAPI {

    /**
     * Vercel cron handler for processing SEC litigation releases. Supports both RSS feed and HTML page scraping methods. Runs daily to check for new litigation releases. Also accepts API key authentication for manual requests.  Args:     request: FastAPI request object     date: Optional date parameter (YYYY-MM-DD format) - mutually exclusive with year/month     year: Optional year parameter - requires month parameter     month: Optional month parameter - requires year parameter     method: Processing method - \"rss\" (default) or \"html\"  Returns:     Processing results
     * Sec Rss Cron
     */
    async secRssCronApiV1CronSecRssGetRaw(requestParameters: SecRssCronApiV1CronSecRssGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['date'] != null) {
            queryParameters['date'] = requestParameters['date'];
        }

        if (requestParameters['year'] != null) {
            queryParameters['year'] = requestParameters['year'];
        }

        if (requestParameters['month'] != null) {
            queryParameters['month'] = requestParameters['month'];
        }

        if (requestParameters['method'] != null) {
            queryParameters['method'] = requestParameters['method'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/cron/sec-rss/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Vercel cron handler for processing SEC litigation releases. Supports both RSS feed and HTML page scraping methods. Runs daily to check for new litigation releases. Also accepts API key authentication for manual requests.  Args:     request: FastAPI request object     date: Optional date parameter (YYYY-MM-DD format) - mutually exclusive with year/month     year: Optional year parameter - requires month parameter     month: Optional month parameter - requires year parameter     method: Processing method - \"rss\" (default) or \"html\"  Returns:     Processing results
     * Sec Rss Cron
     */
    async secRssCronApiV1CronSecRssGet(requestParameters: SecRssCronApiV1CronSecRssGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.secRssCronApiV1CronSecRssGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Vercel cron handler for processing SEC litigation releases. Supports both RSS feed and HTML page scraping methods. Runs daily to check for new litigation releases. Also accepts API key authentication for manual requests.  Args:     request: FastAPI request object     date: Optional date parameter (YYYY-MM-DD format) - mutually exclusive with year/month     year: Optional year parameter - requires month parameter     month: Optional month parameter - requires year parameter     method: Processing method - \"rss\" (default) or \"html\"  Returns:     Processing results
     * Sec Rss Cron
     */
    async secRssCronApiV1CronSecRssGet_1Raw(requestParameters: SecRssCronApiV1CronSecRssGet0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['date'] != null) {
            queryParameters['date'] = requestParameters['date'];
        }

        if (requestParameters['year'] != null) {
            queryParameters['year'] = requestParameters['year'];
        }

        if (requestParameters['month'] != null) {
            queryParameters['month'] = requestParameters['month'];
        }

        if (requestParameters['method'] != null) {
            queryParameters['method'] = requestParameters['method'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/cron/sec-rss`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Vercel cron handler for processing SEC litigation releases. Supports both RSS feed and HTML page scraping methods. Runs daily to check for new litigation releases. Also accepts API key authentication for manual requests.  Args:     request: FastAPI request object     date: Optional date parameter (YYYY-MM-DD format) - mutually exclusive with year/month     year: Optional year parameter - requires month parameter     month: Optional month parameter - requires year parameter     method: Processing method - \"rss\" (default) or \"html\"  Returns:     Processing results
     * Sec Rss Cron
     */
    async secRssCronApiV1CronSecRssGet_1(requestParameters: SecRssCronApiV1CronSecRssGet0Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.secRssCronApiV1CronSecRssGet_1Raw(requestParameters, initOverrides);
        return await response.value();
    }

}
